<template>
	<v-autocomplete
		:value="model"
		:items="filterItems"
		:filter="(item, text) => item.type?.includes(text) || item.header?.includes(text)"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		hide-no-data
		chips
		return-object
		multiple
		dense
		outlined
		hide-details="auto"
		:menu-props="{ maxHeight: 200 }"
		@focus="$emit('focus')">
		<template v-slot:item="{ item, on, attrs }">
			<v-list-item
				@click="(e) => addItem(item)"
				v-on="on"
				v-bind="attrs"
				class="filter-rating-item"
				:style="`width: ${100 / filterItems.filter((e) => e.type === item.type).length}%`">
				{{ item.level }}
			</v-list-item>
		</template>

		<template v-slot:selection="{ item }">
			<v-chip
				small
				close
				@click:close="deleteItem(item)">
				{{ item.type }} - {{ item.level }}
			</v-chip>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'BRating',

	props: {
		label: { type: String },
		items: { default: () => [], require: true },
		loading: { default: false, type: Boolean },
		disabled: { default: false, type: Boolean },
		numberOfLevel: { default: 5, type: Number },
		textValue: { default: 'name', type: String },

		value: { default: null, require: true },
	},

	computed: {
		filterItems() {
			const x = [];
			this.items.forEach((e) => {
				x.push({ header: e[this.textValue] });
				const levels = this.numberOfLevel;
				for (let i = 1; i <= levels; i++) {
					x.push({ level: i, type: e[this.textValue], value: e[this.textValue] + `-${i}`, ...e });
				}
			});
			return x;
		},
		model: {
			get() {
				return this.value || [];
			},
			set(newVal) {
				this.$emit('input', newVal);
			},
		},
	},

	methods: {
		addItem(item) {
			const index = this.model.findIndex((e) => e.type === item.type);

			if (index === -1) {
				this.model = [...this.model, item];
			} else {
				const value = [...this.model];
				value.splice(index, 1, item);
				this.model = value;
			}
		},
		deleteItem(item) {
			const index = this.model.findIndex((e) => e.type === item.type);

			if (index !== -1) {
				const value = [...this.model];
				value.splice(index, 1);
				this.model = value;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.filter-rating-item {
	display: inline-block;
	text-align: center;
	min-height: 2em;
	padding: 0.25em 0;
}
</style>
